import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FaEnvelope, FaCheckCircle, FaArrowLeft } from 'react-icons/fa';
import './InscriptionSuccess.css';

const InscriptionSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { email = '', verificationSent = true } = location.state || {};

  const handleResendEmail = () => {
    // Ici tu pourras implémenter le renvoi d'email si nécessaire
    alert('Fonctionnalité de renvoi d\'email à implémenter');
  };

  return (
    <div className="inscription-success-container">
      <div className="inscription-success-card">
        <div className="success-icon-container">
          <FaCheckCircle className="success-icon-large" />
        </div>
        
        <h2>Inscription réussie !</h2>
        
        <div className="verification-message">
          <FaEnvelope className="envelope-icon" />
          <p>
            <strong>Un email de vérification vous  a été envoyé</strong><br />
            <span className="user-email">{email}</span>
          </p>
        </div>
        
        <div className="instructions">
          <h3>Prochaines étapes :</h3>
          <ol>
            <li>Vérifiez votre boîte email</li>
            <li>Cliquez sur le lien de vérification</li>
            <li>Confirmez votre compte</li>
            <li>Connectez-vous à la plateforme</li>
          </ol>
        </div>
        
        <div className="action-buttons">
          {/* <button 
            onClick={handleResendEmail}
            className="resend-email-btn"
          >
            <FaEnvelope />
            Renvoyer l'email
          </button> */}
          
          <Link to="/connexion" className="login-now-btn">
            Se connecter maintenant
          </Link>
        </div>
        
        <div className="tips">
          <h4>Conseils :</h4>
          <ul>
            <li>Vérifiez votre dossier "Spam" ou "Courrier indésirable"</li>
            <li>Le lien expire dans 24 heures</li>
            <li>Contactez-nous si vous ne recevez pas l'email</li>
          </ul>
        </div>
        
        <Link to="/" className="back-home-link">
          <FaArrowLeft />
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default InscriptionSuccess;